import Styled from 'styled-components/macro';
import {tokensForThemeProvider} from '@forecast-it/design-system';
import {CSS_CONSTANTS} from '../../css_variables';

const spacing = tokensForThemeProvider.sky.sys.spacing;

export const InitialPlanPageWrapper = Styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	color:${CSS_CONSTANTS.v2_text_gray};
	.date-picker-button-container-v3 .date-picker-button.locked {
		opacity: 1;
	}
`;

export const SettingsPageWrapper = Styled.div`
	padding: 0 ${spacing[800]};
	width: 748px;
`;

export const ContentContainer = Styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const BackNavigationWrapper = Styled.div`
	margin: 0 0 ${spacing[600]} ${spacing[800]};
	display:flex;
	flex-direction: column;
`;

export const BackNav = Styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: ${spacing[200]};
	div{
		font-size: 13px;
		color: #a1a1a1;
		font-weight: 500;
		margin: 0;
		padding: 0;
		display: flex
	}
	div {
		display: flex;
		margin-right: ${spacing[100]};

	}
`;

export const HeaderBarStyled = Styled.div`
	.header-bar {
		padding-left: 66px;
		padding-right: 66px;
		padding-bottom: ${spacing[600]};
	}
`;

export const IconWrapper = Styled.div`
	margin-left: 5px;
`;

export const AlertContainer = Styled.div`
	margin: ${spacing[600]} ${spacing[450]} 0 ${spacing[600]};
`;

export const LockedBannerContainer = Styled.div`
	margin: ${spacing[600]} ${spacing[800]} ${spacing[400]};
`;

export const QuoteActivityContainer = Styled.div`
	margin: ${spacing[600]} ${spacing[800]};

	${LockedBannerContainer} + & {
		margin-top: ${spacing[200]};
	}
`;
